"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var axios_1 = __importDefault(require("axios"));
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var UserFeedbackButton = function (props) {
    var _a = react_1.default.useState(false), feedbacked = _a[0], setFeedbacked = _a[1];
    var _b = react_1.default.useState(props.feedbackCount), feedbackCount = _b[0], setFeedbackCount = _b[1];
    var handleClick = function () {
        axios_1.default
            .post(props.apiReviewUserFeedbacksPath)
            .then(function () {
            setFeedbacked(true);
            setFeedbackCount(feedbackCount + 1);
        })
            .catch(function () {
            dialog_store_1.default.showErrorDialog('役に立ったのフィードバックに失敗しました');
        });
    };
    return (react_1.default.createElement("div", { className: "coReviewsUserFeedbackButton-Container" },
        react_1.default.createElement("div", { className: "coReviewsUserFeedbackButton-Description" },
            react_1.default.createElement("span", { className: "coReviewsUserFeedbackButton-Description_FeedbackCount" }, feedbackCount),
            react_1.default.createElement("span", { className: "coReviewsUserFeedbackButton-Description_FeedbackCountUnit" }, "\u4EBA"),
            "\u306E\u304A\u5BA2\u69D8\u304C\u5F79\u306B\u7ACB\u3063\u305F",
            react_1.default.createElement("br", { className: "sp_only" }),
            "\u3068\u8003\u3048\u3066\u3044\u307E\u3059"),
        feedbacked
            ? (react_1.default.createElement("button", { type: "button", className: "coReviewsUserFeedbackButton-Button coReviewsUserFeedbackButton-Button-disabled" }, "\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u6E08\u307F"))
            : (react_1.default.createElement("button", { type: "button", onClick: handleClick, className: "coReviewsUserFeedbackButton-Button" }, "\u5F79\u306B\u7ACB\u3063\u305F"))));
};
exports.default = UserFeedbackButton;
